var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',[_c('div',{staticClass:"copyright"},[_c('p',[_vm._v(" © Roadink GLB © "+_vm._s(new Date().getFullYear())+". All Rights Reserved ")]),_vm._m(0)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_c('a',{staticClass:"icp",attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("粤ICP备2025481464号-2")])])
}]

export { render, staticRenderFns }